






























import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';
import { DynamicScroller } from 'vue-virtual-scroller';
import { cloneDeep } from 'lodash';
function filterOptions(options) {
	return options.filter((item) => {
		if (item.isDelete !== 1) {
			let children = filterOptions(item.children || []);
			item.children = children.length ? children : null;
			return true;
		}
	});
}
@Component({
	components: {
		DynamicScroller,
	},
})
export default class extends Vue {
	@Prop({ default: () => ({}) }) public item!: any;
	@Prop({ default: () => ({}) }) public form!: any;
	private currentOptions: any = [];
	private indexBar: any = [];
	private popupValueArr: any = [];
	private selectVal: any = [];
	private showPicker = false;
	private get options() {
		return filterOptions(cloneDeep(this.item.options));
	}
	private close(item) {
		this.showPicker = false;
	}
	// 选中二级目录
	private changIndex(item) {
		if (item.children) {
			this.currentOptions = item.children;
			this.indexBar.push(item);
		}
	}
	// 深度递归
	private recursion(options, val, valArr) {
		let key = '';
		for (let i = 0; i < options.length; i++) {
			if (options[i].key === val) {
				this.selectVal.unshift(options[i]);
				valArr.unshift(options[i].key);
				key = options[i].key;
				break;
			} else {
				if (options[i].children && options[i].children.length > 0) {
					if (this.recursion(options[i].children, val, valArr)) {
						this.selectVal.unshift(options[i]);
						valArr.unshift(options[i].key);
						key = options[i].key;
						break;
					}
				}
			}
		}
		return key;
	}
	// 确定
	private comfirm() {
		const valArr = [];
		this.selectVal = [];
		this.recursion(this.options, this.popupValueArr, valArr);
		this.form.filterValue = valArr;
		this.showPicker = false;
		this.$emit('change');
	}

	private open() {
		this.showPicker = true;
		this.currentOptions = this.options;
	}
	private cancel() {
		this.selectVal = [];
		this.showPicker = false;
		this.popupValueArr = [];
		this.form.filterValue = '';
		this.$emit('change');
	}
	private clear() {
		this.selectVal = [];
	}
	@Watch('$route.params.viewId')
	private ChildChanged() {
		this.selectVal = [];
	}
}
